var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnnotateEraser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.384 1.5a1.25 1.25 0 0 0-1.768 0L1.5 11.616a1.25 1.25 0 0 0 0 1.768L6.616 18.5a1.25 1.25 0 0 0 1.768 0L18.5 8.384a1.25 1.25 0 0 0 0-1.768zM5.884 9 12.5 2.384 17.616 7.5 11 14.116zM5 9.884 2.384 12.5 7.5 17.616 10.116 15zM9.652 19H19v-1.25h-8.098zm1.906-13.558 3 3 .884-.884-3-3z",
  clipRule: "evenodd"
})));
export default SvgAnnotateEraser;